'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'ballot-check';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f733';
var svgPathData = 'M128 352H96c-8.836 0-16 7.164-16 16v32C80 408.8 87.16 416 96 416h32c8.836 0 16-7.164 16-16v-32C144 359.2 136.8 352 128 352zM96 160h32c8.836 0 16-7.164 16-16v-32C144 103.2 136.8 96 128 96H96C87.16 96 80 103.2 80 112v32C80 152.8 87.16 160 96 160zM344 360h-144c-13.25 0-24 10.75-24 24s10.75 24 24 24h144c13.25 0 24-10.75 24-24S357.3 360 344 360zM171.3 220.7c-6.25-6.25-16.38-6.25-22.62 0L112 257.4L99.31 244.7c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62l24 24C103.8 294.4 107.9 296 112 296s8.188-1.562 11.31-4.688l48-48C177.6 237.1 177.6 226.9 171.3 220.7zM344 232h-112C218.8 232 208 242.8 208 256s10.75 24 24 24h112c13.25 0 24-10.75 24-24S357.3 232 344 232zM384 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V64C448 28.65 419.3 0 384 0zM400 448c0 8.824-7.178 16-16 16H64c-8.822 0-16-7.176-16-16V64c0-8.824 7.178-16 16-16h320c8.822 0 16 7.176 16 16V448zM344 104h-144C186.8 104 176 114.8 176 128s10.75 24 24 24h144c13.25 0 24-10.75 24-24S357.3 104 344 104z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBallotCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;